const wrapper = "_mww4ek3lp";
const rightContainer = "_mwrb8xiop";
const progressText = "_mwpyrw7i2";
const loader = "_mwl1lycztz";

export { loader, progressText, rightContainer, wrapper };
import "./_audio-player.full.linaria.module.css";
//# sourceMappingURL=_audio-player.full.js.map
